// extracted by mini-css-extract-plugin
export default {"base":"qkOg3","number":"KBf29","title":"zYuyb"};